// 게임 글자체 — **단일 출처**. UI(CSS)든 월드 라벨이든 여기 아니면 worldFont.js 다.
//
// ── 왜 이 파일이 생겼나 ────────────────────────────────────────────
// 같은 상수를 13개 파일이 **각자 선언**하고 있었다. 그중 11개는 Cinzel, 2개는 Pretendard 로
// 값이 이미 갈려 있었고, **둘 다 어디서도 로드되지 않아** 전부 폴백(Noto Sans KR · OS 기본)
// 으로 그려지고 있었다. CSS 는 못 받아온 폰트를 조용히 폴백하므로 에러도 경고도 안 난다 —
// 그래서 「우리 폰트는 Cinzel」이라고 믿는 상태가 몇 달 갔다.
//
// 상수가 13벌이면 글자체를 바꾸는 일이 13번의 편집이 된다. 한 벌이면 한 줄이다.
// **이 파일의 존재 이유가 그거다** — 어떤 글자체가 최종인지가 아니라, 바꾸는 값이 싸지는 것.
//
// ── 왜 Cinzel 을 살리지 않고 지웠나 ──────────────────────────────────────────
// ① 애초에 로드된 적이 없다(index.css 는 Noto Sans KR 만 받았다) — 즉 「원복」할 상태가 없다.
// ② 라틴·숫자 전용 폰트라 살려 놓으면 한글은 뒤쪽 폰트가 그리고 **숫자만 판타지 세리프로 튄다.**
// ③ 이 게임은 복셀이다. 세리프는 획 굵기가 변하고(가로 얇음) 골격에 손맛이 있어, 같은 단위를
//    반복해 쌓는 복셀의 문법과 정면으로 어긋난다. 자세한 판정은 /tech lab-game-typography.
//
// ── 왜 Pretendard 한 패밀리인가 ─────────────────────────────────────────────
// 복셀 월드는 나무도 바위도 집도 **같은 정육면체를 굵기·개수만 바꿔** 짓는다. 타이포의 같은
// 문법이 「한 패밀리를 굵기로만 가르는 것」이고, 글자체를 두 개 섞는 건 복셀 월드에 매끈한
// 구(球)를 하나 놓는 것과 같다. Pretendard 는 후보 중 유일하게 **OFL(서브셋·변형 자유)** 이면서
// **굵기가 연속(가변축 45~930)** 이라 그 한 패밀리 전략이 실제로 가능하다.
//
// 폰트 파일은 index.css 의 @font-face 가 로드한다(자체 호스팅 · KS X 1001 서브셋 · 가변 1파일).
// 여기 이름을 바꾸려면 그쪽 @font-face 도 같이 봐야 한다 — 이름만 바꾸면 또 조용히 폴백한다.

/** UI 전역 글자체. 새 컴포넌트는 이걸 import 한다 — 절대 다시 선언하지 않는다. */
export const GAME_FONT = "'Pretendard', system-ui, -apple-system, sans-serif";

/**
 * 숫자가 바뀌어도 자리가 안 흔들리게 하는 고정폭 숫자.
 * HP·골드·레벨·가격처럼 **매 프레임 값이 바뀌는 자리**에 쓴다. 안 쓰면 1,280 → 1,299 에서
 * 글자 폭이 달라져 옆 요소가 좌우로 떤다.
 *   style={{ ...NUM }}  또는  style={{ fontVariantNumeric: 'tabular-nums' }}
 */
export const NUM = { fontVariantNumeric: 'tabular-nums' };

/**
 * 굵기 위계 — 「크기」가 아니라 「굵기」로 층을 만든다(복셀이 같은 블록을 개수로 쌓듯이).
 * 새 화면을 그릴 때 이 네 개 밖의 값을 쓰기 전에 한 번 의심한다.
 */
export const W = {
  body: 400,    // 본문·설명 — 퀘스트/도감/아이템은 양이 많다. 여기서 개성 부리면 피로해진다
  label: 500,   // 라벨·보조 정보
  strong: 700,  // 강조·이름·수치
  title: 800,   // 패널 제목
};
